<div class="map" #map></div>
<div class="map-item-popup" #mapPopup *ngIf="itemSelected">
  <a [routerLink]="['/fiche',itemSelected.Slug+'-'+itemSelected.ExternalId]" [target]="'_blank'"  class="map-item-popup-media-container">
    <media-attachment [forceBackground]="true" [alt]="itemSelected.Title" [sizeXL]="10" [sizeLG]="10" [sizeMD]="10" [sizeSM]="10" [sizeXS]="10" class="synapi-item-media" [url]="itemSelected.ImageUrl"></media-attachment>
  </a>
  <div class="map-item-popup-inner">
    <a [routerLink]="['/fiche',itemSelected.Slug+'-'+itemSelected.ExternalId]" [target]="'_blank'" class="map-item-popup-title">{{ itemSelected.Title }}</a>
    <div class="map-item-popup-informations">
      <div class="map-item-popup-city"><i class="lvi-thel-lieu"></i> {{ itemSelected.AdressePrincipale.Commune }}</div>
      <div class="map-item-popup-category" *ngIf="itemSelected.Categorie?.id!='evenements'">{{ itemSelected.Categorie?.name }}</div>
      <div class="map-item-popup-item-openings" *ngIf="itemSelected.Categorie?.id=='evenements' && itemSelected.LargeOuverturePeriode">
        <i class="lvi-thel-reservation"></i>&nbsp;
        <span *ngIf="(itemSelected.LargeOuverturePeriode.Start|date: 'yMd') != (itemSelected.LargeOuverturePeriode.End|date: 'yMd')" i18n="@@DateFromTo">Du {{ itemSelected.LargeOuverturePeriode.Start|date:"d MMM"}} au {{ itemSelected.LargeOuverturePeriode.End|date:"d MMM"}}
          </span>
        <span *ngIf="(itemSelected.LargeOuverturePeriode.Start|date: 'yMd') == (itemSelected.LargeOuverturePeriode.End|date: 'yMd')" i18n="@@DateThe">Le {{ itemSelected.LargeOuverturePeriode.Start|date:"d MMMM y"}}
          </span>
      </div>
    </div>
    <div class="map-item-popup-bookmark">
      <synapi-bookmark-toggle [item]="itemSelected"></synapi-bookmark-toggle>
    </div>
  </div>
</div>

